import * as React from 'react'
import moment from 'moment'
import { Modal, Button, Skeleton } from 'antd'
import { InventoryLogAPI } from '@getgreenline/inventory'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { InventoryLogsTable } from '../../../../../components/InventoryLogs/InventoryLogsTable'
import { LoadingAnimation } from '../../../../../components/LoadingAnimation'
import { monthType } from '../../../../../components/Input/MonthSelector'
import { dayjs } from '../../../../../utilities/dayjs'

interface IProps {
  canUpdateInventoryLogs: boolean
  companyId: number
  onHide: () => void
  productName: string
  productId: string
  locationIds: number[]
  month: monthType
  year: number
}

interface IState {
  isLoading: boolean
  logs: IInventoryLog[]
  limit: number
}

export class ViewAllLogsModal extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      isLoading: true,
      logs: [],
      limit: 20,
    }
  }

  componentDidMount() {
    this.load()
  }

  load = async () => {
    const { locationIds, companyId, year, month, productId } = this.props
    const startDate = `${year}-${month}-01`
    const endDate = moment(startDate).endOf('month').format('YYYY-MM-DD')
    const veryLargeLimit = 999999
    const logsPromises = locationIds.map((locationId) => {
      return InventoryLogAPI.getInventoryLogs(companyId, {
        limit: veryLargeLimit,
        offset: 0,
        locationId: locationId,
        productIds: [productId],
        startDate: dayjs(startDate).startOf('day').toDate(),
        endDate: dayjs(endDate).endOf('day').toDate(),
      })
    })
    const logsFromLocations = await Promise.all(logsPromises)
    const flatLogs = logsFromLocations
      .filter((logsFromLocation) => logsFromLocation.data.length > 0)
      .reduce((prev: IInventoryLog[], next) => {
        return [...prev, ...next.data]
      }, [])

    this.setState({
      logs: flatLogs,
      isLoading: false,
    })
  }

  render() {
    const { logs, isLoading } = this.state
    const { onHide, productName, companyId } = this.props

    return (
      <Modal
        title={`${productName}`}
        width={690}
        visible={true}
        footer={[
          <Button key='cancel' onClick={() => this.props.onHide()}>
            Cancel
          </Button>,
        ]}
        onCancel={() => onHide()}
      >
        {isLoading ? (
          <Skeleton active />
        ) : (
          <InventoryLogsTable
            companyId={companyId}
            logs={logs}
            onChange={this.load}
            isLoading={isLoading}
          />
        )}
      </Modal>
    )
  }
}
